import reduxCrud from 'redux-crud';

const transactionsActionCreators = reduxCrud.actionCreatorsFor('transactions', {
  key: 'id',
});
const actionTypes = reduxCrud.actionTypesFor('transactions', { key: 'id' });

export default transactionsActionCreators;
export { actionTypes };
